import React, {useState, useEffect, useRef, useCallback} from 'react';
import {Link, useHistory, Redirect} from 'react-router-dom';
import Form, {
    Item,
    Label,
    ButtonItem,
    ButtonOptions,
    RequiredRule,
    CustomRule,
    EmailRule
} from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import LoadIndicator from 'devextreme-react/load-indicator';
import {createAccount} from '../../api/auth';
import './create-account-form.scss';
import {CheckBox} from 'devextreme-react/check-box';
import {Popup, ToolbarItem} from 'devextreme-react/popup';
import TermsOfService from '../policy/terms-of-service';
import PrivacyPolicy from '../policy/privacy-policy';
import {Button} from 'devextreme-react/button';
import ScrollView from 'devextreme-react/scroll-view';

export default function (props) {
    const history = useHistory();
    const [loading,setLoading] = useState(false);
    const [isTermOfServiceVisible,setIsTermOfServiceVisible] = useState();
    const [isPolicyVisible, setIsPolicyVisible] = useState();
    const [isTermOfServiceRead, setIsTermOfServiceRead] = useState(false);
    const [isPolicyRead, setIsPolicyRead] = useState(false);
    const formData = useRef({});
    const [passwordMode, setPasswordMode] = useState('password');
    const [checkBox, setCheckBox] = useState(false);
    const [msg, setMsg] = useState();
    const TermsOk = {
        text: 'Agree',
        type: 'default',
        onClick: () => {setIsTermOfServiceRead(true); setIsTermOfServiceVisible(false)}
    }
    const PolicyOk = {
        text: 'Agree',
        type: 'default',
        onClick: () => {setIsPolicyRead(true); setIsPolicyVisible(false)}
    }

    useEffect(()=>{
        if(isTermOfServiceRead&&isPolicyRead)
        setCheckBox(true)
    },[isTermOfServiceRead,isPolicyRead]);

    const onValueChanged = (args) => {
        if(isPolicyRead && isTermOfServiceRead)
            setCheckBox(true);
        else
            setCheckBox(args.value)
    }
    const onSubmit = useCallback(async(e) => {
        e.preventDefault();
        // const roles = "user";
        const roles = "user";
        const {username, email, password, companyName} = formData.current;
        setLoading(true);

        await createAccount({ username, email, password, companyName, roles }).then( async(result) =>{
            if (result.status === 201) {
                setLoading(false);
                history.push({pathname: "/account",state: { email: result.data.data }});
            }
        }).catch(err=>{console.log(err); 
            if(err.toString().includes(404)) {
                setLoading(false); setMsg(`account with email ${email} already exist`);
            }
        })
    }, [history]);

    const confirmPassword = useCallback(({value}) => value === formData.current.password, []);

    const emailEditorOptions = {
        stylingMode: 'filled',
        placeholder: 'Email',
        mode: 'email'
    };

    const userNameEditorOptions = {
        stylingMode: 'filled',
        placeholder: 'Username',
    };

    const companyNameEditorOptions = {
        stylingMode: 'filled',
        placeholder: 'Company Name',
    };

    const passwordEditorOptions = {
        stylingMode: 'filled',
        placeholder: 'Password',
        mode: passwordMode,
        buttons:[{
            location:"after",
            name:"passwordIcon",
            options:{
                icon:'fa fa-eye',
                onClick: ()=> passwordMode=== 'password'? setPasswordMode('text'):setPasswordMode('password'),
            }
            }]
    };
    const confirmedPasswordEditorOptions = {
        stylingMode: 'filled',
        placeholder: 'Confirm Password',
        mode: passwordMode,
        buttons:[{
            location:"after",
            name:"resetpasswordIcon",
            options:{
                icon:'fa fa-eye',
                onClick: ()=> passwordMode=== 'password'? setPasswordMode('text'):setPasswordMode('password'),
            }
            }]
    };

    
    return (
        <React.Fragment>
            <Popup
                title="Terms Of Service"
                visible={isTermOfServiceVisible}
                width={'50%'}
                onHiding={e => setIsTermOfServiceVisible(false)}>
                <ScrollView>
                    <TermsOfService/>
                </ScrollView>
                <ToolbarItem
                widget="dxButton"
                location="after"
                toolbar='bottom'
                options={TermsOk}></ToolbarItem>
            </Popup>
            <Popup
                title="Privacy Policy"
                visible={isPolicyVisible}
                width={'50%'}
                onHiding={e => setIsPolicyVisible(false)}>
                <ScrollView>
                    <PrivacyPolicy/>
                </ScrollView>
            <ToolbarItem
                widget="dxButton"
                location="after"
                toolbar='bottom'
                options={PolicyOk}></ToolbarItem>
            </Popup>
            <form className={'create-account-form'} onSubmit={onSubmit}>
                <div className={'error-msg'}>{msg}</div>
                <Form formData={formData.current} disabled={loading}>
                    <Item
                        dataField={'username'}
                        editorType={'dxTextBox'}
                        editorOptions={userNameEditorOptions}>
                        <RequiredRule message="Username is required"/>
                        <Label visible={false}/>
                    </Item>
                    <Item
                        dataField={'companyName'}
                        editorType={'dxTextBox'}
                        editorOptions={companyNameEditorOptions}>
                        <RequiredRule message="Company is required"/>
                        <Label visible={false}/>
                    </Item>
                    <Item
                        dataField={'email'}
                        editorType={'dxTextBox'}
                        editorOptions={emailEditorOptions}>
                        <RequiredRule message="Email is required"/>
                        <EmailRule message="Email is invalid"/>
                        <Label visible={false}/>
                    </Item>
                    <Item
                        dataField={'password'}
                        editorType={'dxTextBox'}
                        editorOptions={passwordEditorOptions}>
                        <RequiredRule message="Password is required"/>
                        <Label visible={false}/>
                    </Item>
                    <Item
                        dataField={'confirmedPassword'}
                        editorType={'dxTextBox'}
                        editorOptions={confirmedPasswordEditorOptions}>
                        <RequiredRule message="Password is required"/>
                        <CustomRule
                            message={'Passwords do not match'}
                            validationCallback={confirmPassword}/>
                        <Label visible={false}/>
                    </Item>
                    <Item>
                        <div className='policy-info'>
                            <div>
                                <CheckBox className={'check-policy'} value={checkBox} onValueChanged={onValueChanged} />
                                 I have read &amp; agree to the 
                                <Button
                                    type="default"
                                    stylingMode="text"
                                    onClick={() => {
                                    setIsPolicyVisible(true)
                                }}>Privacy Policy </Button>&amp;
                                <Button
                                    type="default"
                                    stylingMode="text"
                                    onClick={() => {
                                    setIsTermOfServiceVisible(true)
                                }}>
                                    Terms of Service.</Button>
                            </div>
                        </div>
                    </Item>
                    <ButtonItem>
                        <ButtonOptions width={'100%'} type={'default'} useSubmitBehavior={true}>
                            <span className="dx-button-text">
                                {loading
                                    ? <LoadIndicator width={'24px'} height={'24px'} visible={true}/>
                                    : 'Create a new account'
}
                            </span>
                        </ButtonOptions>
                    </ButtonItem>
                    <Item>
                        <div className={'login-link'}>
                            Have an account?
                            <Link to={'/login'}>Sign In</Link>
                        </div>
                    </Item>
                </Form>
            </form>
        </React.Fragment>
    );
}